import { xmlToString } from '../xmlUtility';

const $ = typeof window !== 'undefined' && window.jQuery;

export const XHTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';

function needToAddNamespace() {
    if (!('lazy' in needToAddNamespace)) {
        var xtree = $.parseXML('<n/>');
        $(xtree).find('n').append($('<p>'));

        var xstr = xmlToString(xtree);

        needToAddNamespace.lazy = xstr.indexOf(XHTML_NAMESPACE) === -1;
    }

    return needToAddNamespace.lazy;
}

const hasXhtmlAttribute = '[xmlns="' + XHTML_NAMESPACE + '"]';

const addXhtmlNamespace = (richText) =>
    richText
        .filter(function (i, nd) {
            return nd.nodeType === 1;
        })
        .each(function (i, el) {
            el.setAttribute('xmlns', XHTML_NAMESPACE);
        });

const removeNamespace = (richText) =>
    richText
        .find(hasXhtmlAttribute)
        .addBack(hasXhtmlAttribute)
        .each(function (i, el) {
            el.removeAttribute('xmlns');
        });

// String -> [DOMNode]
export function buildRichText(string) {
    if (!$) {
        return [];
    }

    let richText = $($.parseHTML(string));

    if (needToAddNamespace()) {
        addXhtmlNamespace(richText);
    } else {
        removeNamespace(richText);
    }

    return richText.toArray();
}

export function setRichTextString(node, string) {
    $(node).empty().append(buildRichText(string));
}
